@switch (dataAdministrationType) {

<!-- CLIPPING CARD -->
@case ('CLIPPING') {
<div class="client-card clipping-card">
	<div class="card-main">
		<!-- Thumbnail: real image, else reseller logo, else a neutral medium-type icon -->
		<div class="card-thumbnail">
			@if (getDisplayField('mediaUrl') !== 'fallback_image') {
			<img [src]="getDisplayField('mediaUrl')" alt="" />
			} @else if (resellerSettingsContext?.navBar?.logo) {
			<div class="fallback-image">
				<img [src]="resellerSettingsContext?.navBar?.logo" alt="logo" />
			</div>
			} @else {
			<div class="fallback-icon">
				<mat-icon>{{ getMediumTypeIcon() }}</mat-icon>
			</div>
			}
		</div>

		<!-- Content -->
		<div class="card-content">
			<!-- Row 1: medium · type (small, gray, above the title) -- date + actions on the right -->
			<div class="card-top-row">
				<div class="medium-info" (click)="utils.openLinkInNewTab(typeSafe.url)">
					<mat-icon class="medium-type-icon">{{ getMediumTypeIcon() }}</mat-icon>
					<span class="medium-name">{{ getDisplayField('medium') }}</span>
					@if (typeSafe.medium?.type) {
					<span class="medium-meta-sep">·</span>
					<span class="medium-type-text">{{ getMediumTypeTranslation() }}</span>
					}
					@if (typeSafe.medium?.type === 'TV' && typeSafe.airingTimes && typeSafe.airingTimes.length > 1) {
					<span class="medium-meta-sep">·</span>
					<span class="medium-type-text">{{ 'CLIPS.AIRED_TIMES' | translate: { count: typeSafe.airingTimes.length, times: typeSafe.airingTimes.join(', ') } }}</span>
					}
				</div>
				<div class="card-top-right">
					<span class="medium-date">{{ getDisplayField('publishedDate') }}</span>
					<div class="card-icon-actions">
						<button class="icon-action" matTooltip="{{ 'CLIENT.SINGLE_REPORT' | translate }}" matTooltipPosition="below" (click)="emitAction('PDF_SINGLE')">
							<mat-icon>description</mat-icon>
						</button>
						@if (getDisplayField('relatedCount')) {
						<button class="icon-action" matTooltip="{{ 'CLIENT.GROUP_REPORT' | translate }}" matTooltipPosition="below" (click)="emitAction('PDF_GROUP')">
							<mat-icon>file_copy</mat-icon>
						</button>
						}
						@if (utils.getParameterByName(item, 'screenshotUrl')) {
						<button class="icon-action" matTooltip="{{ 'CLIPS.SCREENSHOT' | translate }}" matTooltipPosition="below" (click)="emitAction('SCREENSHOT')">
							<mat-icon>photo</mat-icon>
						</button>
						}
					</div>
				</div>
			</div>

			<!-- Row 2: Title -->
			<h3 class="card-title" (click)="emitAction('DETAILS')">{{ getDisplayField('title') }}</h3>

			<!-- Row 3: Description -->
			@if (getDisplayField('brief')) {
			<p class="card-description">{{ getDisplayField('brief') }}</p>
			}

			<!-- Row 4: Tags -->
			@if (client?.showTags && (getDisplayField('tags')?.length || typeSafe.competitorOnly)) {
			<div class="card-tags">
				@for (tag of getDisplayField('tags'); track $index) {
				<span class="tag-chip">{{ utils.getParameterByLanguageScript(tag, 'name', true) }}</span>
				}
				@if (typeSafe.competitorOnly) {
				<span class="competitor-badge" [matTooltip]="'CLIPS.COMPETITOR_TOOLTIP' | translate" matTooltipPosition="above">{{ 'CLIPS.COMPETITOR_BADGE' | translate }}</span>
				}
			</div>
			}

			<!-- Row 5: Bottom - related only (date + medium type moved into the header row) -->
			@if (getDisplayField('relatedCount')) {
			<div class="card-bottom-row">
				<div class="card-bottom-right">
					<button class="related-btn" (click)="emitAction('RELATED_CLIPS')">
						{{ 'CLIPS.RELATED_CONTENT' | translate }} (+{{ getDisplayField('relatedCount') }})
						<mat-icon>{{ typeSafe.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
					</button>
				</div>
			</div>
			}

			<!-- Meta strip: metrics / classification / action, in that order. Lives inside
			     card-content so it lines up with the text, not the thumbnail. Absent entirely
			     when the clip has no sentiment row (never a placeholder column). -->
			@if (typeSafe.sentiment) {
			<div class="card-meta-strip">
				<div class="meta-group meta-group-metrics">
					<span class="metric-plain">
						<span class="metric-plain-label">{{ 'CLIPS.REACH' | translate }}</span>
						<span class="metric-plain-value">{{ typeSafe.visibilityIndex }}/100</span>
					</span>
					<span class="medium-meta-sep">·</span>
					<span class="metric-plain"
						[ngClass]="{
							positive: typeSafe.sentiment?.sentimentScore > 0,
							negative: typeSafe.sentiment?.sentimentScore < 0,
							neutral: typeSafe.sentiment?.sentimentScore === 0,
							empty: typeSafe.sentiment?.sentimentScore == null
						}">
						<span class="metric-plain-label">{{ 'CLIPS.INFLUENCE' | translate }}</span>
						<span class="metric-plain-value">
							@if (typeSafe.sentiment?.sentimentScore == null) { / }
							@else if (typeSafe.sentiment.sentimentScore > 0) { +{{ typeSafe.sentiment.sentimentScore }} }
							@else { {{ typeSafe.sentiment.sentimentScore }} }
						</span>
						@if (typeSafe.sentiment?.explanation?.[client?.lang]) {
						<mat-icon class="inline-icon influence-explanation-icon" [matTooltip]="typeSafe.sentiment.explanation[client.lang]" matTooltipClass="wide-tooltip" matTooltipPosition="above">info_outline</mat-icon>
						}
					</span>
				</div>

				@if (typeSafe.sentiment?.sourceType || typeSafe.sentiment?.industryTopics?.length || typeSafe.sentiment?.corporateTopics?.length) {
				<div class="meta-group-divider"></div>
				<div class="meta-group meta-group-classification">
					@if (typeSafe.sentiment?.sourceType) {
					<span class="source-type-text">{{ typeSafe.sentiment.sourceType }}</span>
					}
					@for (topic of typeSafe.sentiment.industryTopics; track topic) {
					<span class="ai-topic-badge industry" [matTooltip]="('CLIPS.INDUSTRY_TOPIC_TOOLTIP' | translate:{ topic: topic })" matTooltipPosition="above"><mat-icon class="ai-topic-icon">factory</mat-icon>{{ topic }}</span>
					}
					@for (topic of typeSafe.sentiment.corporateTopics; track topic) {
					<span class="ai-topic-badge corporate" [matTooltip]="('CLIPS.CORPORATE_TOPIC_TOOLTIP' | translate:{ topic: topic })" matTooltipPosition="above"><mat-icon class="ai-topic-icon">business_center</mat-icon>{{ topic }}</span>
					}
				</div>
				}

				<div class="meta-group meta-group-action">
					<button class="sentiment-btn" [ngClass]="getSentimentClass('POSITIVE')"
						[attr.aria-label]="'CLIPS.SENTIMENT_RATING_TYPE.POSITIVE' | translate"
						[attr.aria-pressed]="getSentimentClass('POSITIVE') ? 'true' : 'false'"
						matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.POSITIVE' | translate }}" matTooltipPosition="below"
						(click)="emitAction('SENTIMENT', { sentimentType: 'POSITIVE' })">
						<mat-icon>thumb_up_off_alt</mat-icon>
					</button>
					<button class="sentiment-btn" [ngClass]="getSentimentClass('NEUTRAL')"
						[attr.aria-label]="'CLIPS.SENTIMENT_RATING_TYPE.NEUTRAL' | translate"
						[attr.aria-pressed]="getSentimentClass('NEUTRAL') ? 'true' : 'false'"
						matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.NEUTRAL' | translate }}" matTooltipPosition="below"
						(click)="emitAction('SENTIMENT', { sentimentType: 'NEUTRAL' })">
						<mat-icon>remove</mat-icon>
					</button>
					<button class="sentiment-btn" [ngClass]="getSentimentClass('NEGATIVE')"
						[attr.aria-label]="'CLIPS.SENTIMENT_RATING_TYPE.NEGATIVE' | translate"
						[attr.aria-pressed]="getSentimentClass('NEGATIVE') ? 'true' : 'false'"
						matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.NEGATIVE' | translate }}" matTooltipPosition="below"
						(click)="emitAction('SENTIMENT', { sentimentType: 'NEGATIVE' })">
						<mat-icon>thumb_down_off_alt</mat-icon>
					</button>
				</div>
			</div>
			}
		</div>
	</div>

	<!-- Related clips expansion -->
	@if (typeSafe.expanded && utils.getParameterByName(item, 'related')) {
	<div class="related-section">
		@for (group of utils.getParameterByName(item, 'related'); track $index) {
		@if (group[1]?.length) {
		<div class="related-group-label">{{ 'MEDIUM.TYPES.' + group[0] | translate }}</div>
		@for (relatedClip of group[1]; track $index) {
		<div class="related-item" (click)="emitAction('DETAILS', { item: relatedClip })">
			<span class="related-date">{{ utils.formatDate(relatedClip.publicationDate) }}</span>
			<span class="related-title">{{ utils.getParameterByLanguageScript(relatedClip, 'title', true) }}</span>

			@if (relatedClip.sentiment != null) {
			<div class="related-sentiment-panel" (click)="$event.stopPropagation()">
				<div class="metric-badge reach">
					<span class="metric-label">{{ 'CLIPS.REACH' | translate }}:</span>
					<span class="metric-value">{{ relatedClip.visibilityIndex }}/100</span>
				</div>
				<div class="metric-badge influence"
					[ngClass]="{
						positive: relatedClip.sentiment?.sentimentScore > 0,
						negative: relatedClip.sentiment?.sentimentScore < 0,
						neutral: relatedClip.sentiment?.sentimentScore === 0,
						empty: relatedClip.sentiment?.sentimentScore == null
					}">
					<span class="metric-label">{{ 'CLIPS.INFLUENCE' | translate }}:</span>
					<span class="metric-value">
						@if (relatedClip.sentiment?.sentimentScore == null) { / }
						@else if (relatedClip.sentiment.sentimentScore > 0) { +{{ relatedClip.sentiment.sentimentScore }} }
						@else { {{ relatedClip.sentiment.sentimentScore }} }
					</span>
					@if (relatedClip.sentiment?.explanation?.[client?.lang]) {
					<mat-icon class="inline-icon influence-explanation-icon" [matTooltip]="relatedClip.sentiment.explanation[client.lang]" matTooltipClass="wide-tooltip" matTooltipPosition="above">info_outline</mat-icon>
					}
				</div>
				<div class="sentiment-group">
					<button class="sentiment-btn" [ngClass]="getSentimentClass('POSITIVE', relatedClip)"
						matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.POSITIVE' | translate }}" matTooltipPosition="below"
						(click)="emitAction('SENTIMENT', { sentimentType: 'POSITIVE', item: relatedClip })">
						<mat-icon>thumb_up_off_alt</mat-icon>
					</button>
					<div class="sentiment-divider"></div>
					<button class="sentiment-btn" [ngClass]="getSentimentClass('NEUTRAL', relatedClip)"
						matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.NEUTRAL' | translate }}" matTooltipPosition="below"
						(click)="emitAction('SENTIMENT', { sentimentType: 'NEUTRAL', item: relatedClip })">
						<mat-icon>remove</mat-icon>
					</button>
					<div class="sentiment-divider"></div>
					<button class="sentiment-btn" [ngClass]="getSentimentClass('NEGATIVE', relatedClip)"
						matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.NEGATIVE' | translate }}" matTooltipPosition="below"
						(click)="emitAction('SENTIMENT', { sentimentType: 'NEGATIVE', item: relatedClip })">
						<mat-icon>thumb_down_off_alt</mat-icon>
					</button>
				</div>
			</div>
			}

			<span class="related-medium">{{ utils.getParameterByLanguageScript(relatedClip.medium, 'name') }}</span>
			@if (group[0] === 'TV' && relatedClip.airingTimes && relatedClip.airingTimes.length > 1) {
			<span class="related-medium airing-times"> · {{ 'CLIPS.AIRED_TIMES' | translate: { count: relatedClip.airingTimes.length, times: relatedClip.airingTimes.join(', ') } }}</span>
			}
			<button class="icon-action" matTooltip="{{ 'CLIENT.SINGLE_REPORT' | translate }}" matTooltipPosition="below"
				(click)="$event.stopPropagation(); emitAction('PDF_SINGLE', { item: relatedClip })">
				<mat-icon>description</mat-icon>
			</button>
		</div>
		}
		}
		}
	</div>
	}
</div>
}

<!-- CONTRACT NOTICES / ANNOUNCEMENTS CARD -->
@case ('CONTRACT_NOTICES') {
<ng-container *ngTemplateOutlet="contractCard"></ng-container>
}
@case ('CONTRACT_ANNOUNCEMENTS') {
<ng-container *ngTemplateOutlet="contractCard"></ng-container>
}

<!-- SALES CARD -->
@case ('SALES') {
<div class="client-card rest-card">
	<div class="card-main">
		<div class="card-content full-width">
			<div class="card-top-row">
				<span class="card-date">
					<mat-icon>calendar_today</mat-icon>
					{{ 'SALES.PUBLISHED_DATE' | translate }}: {{ getDisplayField('publishedDate') }}
				</span>
				@if (getDisplayField('saleDate')) {
				<span class="card-date ms-2">
					<mat-icon>monetization_on</mat-icon>
					{{ 'SALES.SALE_DATE' | translate }}: {{ getDisplayField('saleDate') }}
				</span>
				}
			</div>

			@if (getDisplayField('trustee')) {
			<p class="card-description card-link mb-1" (click)="emitAction('GENERATE_REPORT')">
				{{ getDisplayField('trustee') }}
				<mat-icon class="inline-icon">open_in_new</mat-icon>
			</p>
			}
			@if (getDisplayField('debtor')) {
			@if (getDisplayField('trustee')) {
			<h3 class="card-title not-clickable">{{ getDisplayField('debtor') }}</h3>
			} @else {
			<h3 class="card-title" (click)="emitAction('GENERATE_REPORT')">
				{{ getDisplayField('debtor') }}
				<mat-icon class="inline-icon">open_in_new</mat-icon>
			</h3>
			}
			}

			@if (getDisplayField('placeOfSale') || getDisplayField('location') || getDisplayField('saleType')) {
			<div class="card-bottom-row">
				<div class="card-bottom-left">
					@if (getDisplayField('placeOfSale')) {
					<span class="card-meta">{{ 'SALES.PLACE_OF_SALE' | translate }}: <strong>{{ getDisplayField('placeOfSale') }}</strong></span>
					}
					@if (getDisplayField('placeOfSale') && getDisplayField('location')) {
					<span class="card-meta-divider">|</span>
					}
					@if (getDisplayField('location')) {
					<span class="card-meta">{{ 'SALES.LOCATION' | translate }}: <strong>{{ getDisplayField('location') }}</strong></span>
					}
				</div>
				@if (getDisplayField('saleType')) {
				<div class="card-bottom-right">
					<span class="neutral-type-badge">{{ 'SALES.TYPES.' + getDisplayField('saleType') | translate }}</span>
				</div>
				}
			</div>
			}
		</div>
	</div>
</div>
}

<!-- BANKRUPTCIES CARD -->
@case ('BANKRUPTCIES') {
<div class="client-card rest-card">
	<div class="card-main">
		<div class="card-content full-width">
			<div class="card-top-row">
				<span class="card-date">
					<mat-icon>calendar_today</mat-icon>
					{{ 'BANKRUPTCIES.PUBLISHED_DATE' | translate }}: {{ getDisplayField('publishedDate') }}
				</span>
			</div>

			@if (getDisplayField('company')) {
			<h3 class="card-title" (click)="emitAction('GENERATE_REPORT')">
				{{ getDisplayField('company') }}
				<mat-icon class="inline-icon">open_in_new</mat-icon>
			</h3>
			}

			@if (getDisplayField('embs') || getDisplayField('phase')) {
			<div class="card-bottom-row">
				<div class="card-bottom-left">
					@if (getDisplayField('embs')) {
					<span class="card-meta">{{ 'BANKRUPTCIES.EMBS' | translate }}: <strong>{{ getDisplayField('embs') }}</strong></span>
					}
				</div>
				@if (getDisplayField('phase')) {
				<div class="card-bottom-right">
					<span class="neutral-type-badge">{{ 'BANKRUPTCIES.PHASES.' + getDisplayField('phase') | translate }}</span>
				</div>
				}
			</div>
			}
		</div>
	</div>
</div>
}

<!-- TRANSCRIPTIONS CARD -->
@case ('TRANSCRIPTIONS') {
<div class="client-card rest-card">
	<div class="card-main">
		<div class="card-content full-width">
			<div class="card-top-row">
				@if (getDisplayField('lang')) {
				<img width="19px" [src]="externalAssets + '/flags/' + getDisplayField('lang') + '.svg'" alt="" />
				}
				<span class="card-date ms-2">{{ 'TRANSCRIPTIONS.TRANSCRIPTION_DATE' | translate }}: {{ getDisplayField('createdAt') }}</span>
				<div class="ms-auto">
					@if (item.orderId && item.orderId.startsWith('PENDING-')) {
					<mat-icon class="transcription-type-icon"
						[matTooltip]="'TRANSCRIPTIONS.PENDING_TRANSCRIPTION' | translate" matTooltipPosition="below">
						hourglass_top
					</mat-icon>
					} @else {
					<!-- Type icon hidden for clients. @if (false) used because @for/@if can't be HTML-commented. -->
					@if (false) {
					<mat-icon class="transcription-type-icon"
						[matTooltip]="('TRANSCRIPTIONS.TYPES.' + typeSafe.type) | translate" matTooltipPosition="below">
						{{ typeSafe.type === 'YOUTUBE' ? 'play_circle' : (typeSafe.type === 'FILE' ? 'description' : (typeSafe.type === 'URL' ? 'link' : (typeSafe.type === 'RECORDING' ? 'mic' : 'help'))) }}
					</mat-icon>
					}
					}
				</div>
			</div>

			@if (getDisplayField('fileName') && (typeSafe.url || getDisplayField('url'))) {
			<div class="transcription-file-row">
				<mat-checkbox color="primary" [checked]="item.checked" (change)="emitAction('TOGGLE_SELECTION')"></mat-checkbox>
				<span class="card-title ms-2" (click)="utils.openLinkInNewTab(typeSafe.url || getDisplayField('url'))">
					{{ getDisplayField('fileName') }}
					<mat-icon class="inline-icon">open_in_new</mat-icon>
				</span>
				<div class="ms-auto transcription-actions">
					<button class="icon-action" matTooltip="{{ 'BUTTON.PREVIEW' | translate }}" matTooltipPosition="below" (click)="emitAction('EDIT_TRANSCRIPTION')">
						<mat-icon>visibility</mat-icon>
					</button>
					<button class="icon-action" [disabled]="!hasTranscriptionContent()" matTooltip="{{ 'BUTTON.EXPORT' | translate }}" matTooltipPosition="below" (click)="emitAction('EXPORT_TRANSCRIPTION')">
						<mat-icon>download</mat-icon>
					</button>
				</div>
			</div>
			}

			@if (getDisplayField('content')) {
			<p class="card-description mt-2">{{ getDisplayField('content') }}</p>
			}

			<!-- Only tags the client follows (backend returns all assigned tags). -->
			@if (client?.showTags && getFollowedTranscriptionTags().length) {
			<div class="card-tags mt-2">
				@for (tag of getFollowedTranscriptionTags(); track $index) {
				<span class="tag-chip">{{ utils.getParameterByLanguageScript(tag, 'name', true) }}</span>
				}
			</div>
			}
		</div>
	</div>
</div>
}
}

<!-- Contract notices/announcements shared template -->
<ng-template #contractCard>
	<div class="client-card rest-card">
		<div class="card-main">
			<div class="card-content full-width">
				<div class="card-top-row">
					@if (getDisplayField('medium')) {
					<div class="medium-info" (click)="utils.openLinkInNewTab(typeSafe.url)">
						<mat-icon class="medium-icon-sm">public</mat-icon>
						<span class="medium-name">{{ getDisplayField('medium') }}</span>
					</div>
					}
					@if (getDisplayField('country')) {
					<span
						class="country-flag-circle ms-1"
						[matTooltip]="getDisplayField('country').toUpperCase()"
						matTooltipPosition="above">
						<img [src]="externalAssets + '/flags/' + getDisplayField('country') + '.svg'" alt="" />
					</span>
					}
					<span class="card-date ms-2">
						<mat-icon>calendar_today</mat-icon>
						{{ 'CONTRACT_NOTICES.PUBLISHED_DATE' | translate }}: {{ getDisplayField('publishedDate') }}
					</span>
					@if (getDisplayField('deliveryDate')) {
					<span class="card-date ms-2">
						<mat-icon>event_available</mat-icon>
						{{ 'CONTRACT_NOTICES.DELIVERY_DATE' | translate }}: {{ getDisplayField('deliveryDate') }}
					</span>
					}
					@if (getDisplayField('estimatedPurchaseValue')) {
					<span class="card-meta ms-3">
						<mat-icon class="meta-icon">paid</mat-icon>
						{{ 'CONTRACT_NOTICES.ESTIMATED_PURCHASE_VALUE' | translate }}: {{ getDisplayField('estimatedPurchaseValue') }}
					</span>
					}
					@if (getDisplayField('agreementValue')) {
					<span class="card-meta ms-3">
						<mat-icon class="meta-icon">paid</mat-icon>
						{{ 'CONTRACT_NOTICES.AGREEMENT_VALUE' | translate }}: {{ getDisplayField('agreementValue') }}
					</span>
					}
					<div class="card-icon-actions ms-auto">
						@if (typeSafe.fileUrl && isImageUrl(typeSafe.fileUrl)) {
						<button class="icon-action" matTooltip="{{ 'CLIPS.SCREENSHOT' | translate }}" matTooltipPosition="below"
							(click)="utils.openLinkInNewTab(getFileUrl())">
							<mat-icon>photo</mat-icon>
						</button>
						}
						@if (getDisplayField('eauction')) {
						<span class="eauction-badge" [matTooltip]="'CONTRACT_NOTICES.E_AUCTION' | translate" matTooltipPosition="above">e</span>
						}
					</div>
				</div>

				<p class="card-description mb-1">{{ getDisplayField('content') }}</p>

				<h3 class="card-title" (click)="emitAction('OPEN_LINK')">
					{{ getDisplayField('title') }}
					<mat-icon class="inline-icon">open_in_new</mat-icon>
				</h3>

				<div class="card-bottom-row mt-2">
					<div class="card-bottom-left">
						@if (getDisplayField('contractors')) {
						<span class="contractor-pill">
							<span class="contractor-pill-label">{{ 'CONTRACT_NOTICES.CONTRACTOR' | translate }}:</span>
							<span class="contractor-pill-value">{{ getDisplayField('contractors') }}</span>
						</span>
						}
					</div>
					<button class="related-btn" (click)="emitAction('RELATED_NOTICES')">
						{{ getDisplayField('type') }}
						@if (typeSafe.related?.length) { (+{{ typeSafe.related.length }}) }
						<mat-icon>{{ typeSafe.related?.length ? 'expand_less' : 'expand_more' }}</mat-icon>
					</button>
				</div>
			</div>
		</div>

		@if (typeSafe.related?.length) {
		<div class="related-section">
			@for (relatedItem of typeSafe.related; track $index) {
			<div class="related-notice-card">
				<div class="card-top-row">
					@if (relatedField(relatedItem, 'type')) {
					<span class="neutral-type-badge">{{ relatedField(relatedItem, 'type') }}</span>
					}
					<span class="card-date ms-2">
						<mat-icon>calendar_today</mat-icon>
						{{ 'CONTRACT_NOTICES.PUBLISHED_DATE' | translate }}: {{ relatedField(relatedItem, 'publishedDate') }}
					</span>
					@if (relatedField(relatedItem, 'deliveryDate')) {
					<span class="card-date ms-2">
						<mat-icon>event_available</mat-icon>
						{{ 'CONTRACT_NOTICES.DELIVERY_DATE' | translate }}: {{ relatedField(relatedItem, 'deliveryDate') }}
					</span>
					}
					@if (relatedField(relatedItem, 'estimatedPurchaseValue')) {
					<span class="card-meta ms-3">
						<mat-icon class="meta-icon">paid</mat-icon>
						{{ 'CONTRACT_NOTICES.ESTIMATED_PURCHASE_VALUE' | translate }}: {{ relatedField(relatedItem, 'estimatedPurchaseValue') }}
					</span>
					}
					@if (relatedField(relatedItem, 'agreementValue')) {
					<span class="card-meta ms-3">
						<mat-icon class="meta-icon">paid</mat-icon>
						{{ 'CONTRACT_NOTICES.AGREEMENT_VALUE' | translate }}: {{ relatedField(relatedItem, 'agreementValue') }}
					</span>
					}
				</div>
				@if (relatedField(relatedItem, 'content')) {
				<p class="card-description mb-0">{{ relatedField(relatedItem, 'content') }}</p>
				}
				<span class="card-title" (click)="utils.openLinkInNewTab(relatedItem.url)">
					{{ relatedField(relatedItem, 'title') }}
					<mat-icon class="inline-icon">open_in_new</mat-icon>
				</span>
				@if (relatedField(relatedItem, 'contractors')) {
				<div class="card-bottom-row mt-2">
					<span class="contractor-pill">
						<span class="contractor-pill-label">{{ 'CONTRACT_NOTICES.CONTRACTOR' | translate }}:</span>
						<span class="contractor-pill-value">{{ relatedField(relatedItem, 'contractors') }}</span>
					</span>
				</div>
				}
			</div>
			}
		</div>
		}
	</div>
</ng-template>
